import {
  CONTACT_ROUTE,
  SERVICES_ROUTE,
  KNOWLEDGE_ROUTE,
  PORTFOLIO_ROUTE,
  ABOUT_ROUTE,
  VENTURES_ROUTE,
} from 'routes/constants'

export const sectionData = {
  links: [
    {
      text: 'Services',
      route: SERVICES_ROUTE,
    },
    {
      text: 'Portfolio',
      route: PORTFOLIO_ROUTE,
    },
    {
      text: 'About',
      route: ABOUT_ROUTE,
    },
    {
      text: 'Knowledge',
      route: KNOWLEDGE_ROUTE,
      isExternal: true,
    },
    {
      text: 'Ventures',
      route: VENTURES_ROUTE,
    },
    {
      text: 'Contact us',
      route: CONTACT_ROUTE,
    },
  ],
}
